const currentYear = new Date().getFullYear();

export default {
    currentYear,
};
